import { render, staticRenderFns } from "./YoutubeCampaignShow.vue?vue&type=template&id=64b4e206&"
import script from "./YoutubeCampaignShow.vue?vue&type=script&lang=js&"
export * from "./YoutubeCampaignShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports